var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoBursa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_2526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.492676H24V24.4927H0V0.492676Z",
    fill: "#1F4593"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65154 8.7838C12.4733 5.81252 16.186 4.75823 17.9453 6.42837C18.8894 7.32495 19.0784 8.82409 18.6151 10.4801L16.4371 12.0345C17.1777 10.3014 17.2133 8.76452 16.3711 7.96437C14.9333 6.59895 11.4807 7.90052 8.6594 10.8718C8.13222 11.4252 7.64864 12.0185 7.21297 12.6465C7.66425 11.3587 8.49268 10.0044 9.65154 8.7838V8.7838ZM14.4151 16.2992C11.5094 19.2367 7.7474 20.2267 6.01254 18.5107C5.08125 17.5892 4.92311 16.0759 5.42625 14.4169L7.65311 12.8942C6.86968 14.6252 6.80025 16.1724 7.63083 16.9939C9.0494 18.3967 12.5543 17.1529 15.46 14.2155C16.003 13.6684 16.5031 13.0803 16.9557 12.4562C16.4727 13.7445 15.6091 15.0919 14.4151 16.2992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_2526"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.492676,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBursa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_bursa.e3dc632383232dbd297ac94b608150a8.svg";